
import React      from 'react';
import CSSModules from 'react-css-modules';

import Input from '../Input';

import style from './style.scss';

class SearchInput extends React.Component {

    constructor() {

        super();

        this.state = {
            searchText: ''
        };
    }

    componentWillReceiveProps(nextProps) {

        if (this.initialisedSearchText)
            return;

        this.setState({ searchText: nextProps.initialValue });

        this.initialisedSearchText = true;
    }

    _keyPressed(e) {

        if (e.charCode === 13) {

            this.props.onSearch(this.state.searchText);
        }
    }

    _inputChanged(e) {

        this.setState({
            searchText: e.target.value
        });
    }

    _resetSearchText() {

        this.setState({
            searchText: ''
        });

        this.props.onReset();
    }

    _getResetButton() {

        if (this.state.searchText !== '') {

            return (
                <span onClick={ this._resetSearchText.bind(this) } styleName="reset-icon">&times;</span>
            );
        }
    }

    render() {

        return (
            <div styleName="search-container">

                <Input { ...this.props }
                       value={ this.state.searchText }
                       onChange={ this._inputChanged.bind(this) }
                       onKeyPress={ this._keyPressed.bind(this) }
                       styleName="search-input" />

                { this._getResetButton() }

            </div>
        );
    }
}

export default CSSModules(SearchInput, style);


// WEBPACK FOOTER //
// ./components/SearchInput/index.js